import styled from 'styled-components';
import { token } from '@bynder/design-system';
import { skeletonAnimation } from '../../../constants/styles';

interface SkeletonWidgetProps {
  width: number;
}

export const StyledSkeletonSeparator = styled.div`
  box-sizing: border-box;
  height: 2px;
  width: 800px;
  border: 1px solid ${token.gray75a};
  margin-top: 55px;
`;

export const StyledSkeletonPageTitle = styled.div`
  border-radius: ${token.radiusMedium};
  background-color: ${token.gray75a};
  height: 44px;
  width: 312px;
  ${skeletonAnimation}
`;

export const StyledSkeletonWidget = styled.div<SkeletonWidgetProps>`
  border-radius: ${token.radiusMedium};
  background-color: ${token.gray200};
  height: 8px;
  width: ${props => props.width}px;
  &:nth-child(even) {
    margin-top: ${token.spacing4};
  }
  &:nth-child(odd) {
    margin-top: ${token.spacing5};
  }
  ${skeletonAnimation}
`;
